<template>
  <div class="carousel-container">
    <!-- Carousel Wrapper -->
    <div
      class="carousel-track"
      :style="{
        transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
      }"
    >
      <div v-for="(item, index) in promos" :key="index" class="promo-card">
        <div class="promo-content">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
          <a href="/" class="promo-btn">{{ item.buttonText }}</a>
          <img
            src="/img/banner/swiper-main-bg-1.avif"
            alt=""
            class="promo-bg"
          />
        </div>
        <img :src="item.image" alt="" class="promo-img" />
      </div>
    </div>

    <!-- Navigation -->
    <button class="nav-btn prev" @click="prevSlide">
      <chevron-left-icon />
    </button>
    <button class="nav-btn next" @click="nextSlide">
      <chevron-left-icon style="transform: rotate(180deg)" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon.vue";

const promos = [
  {
    title: "Welcome Pack",
    description: "Grab your Welcome Pack! Up to €900 + 190 FS await!",
    buttonText: "Join now",
    image: "/img/banner/swiper-main-hero-1.avif",
  },
  {
    title: "Progression Hub",
    description: "Level up in our loyalty system and unlock exclusive rewards.",
    buttonText: "Level Up Now",
    image: "../../assets/img/progression-hub.png",
  },
  {
    title: "Tuesday Reload",
    description: "Every Tuesday 40% bonus up to €250. Reload and play!",
    buttonText: "Get Bonus",
    image: "/assets/img/tuesday-reload.png",
  },
  {
    title: "Weekend Boost",
    description: "50% bonus every weekend to keep the fun going.",
    buttonText: "Claim Now",
    image: "/assets/img/weekend-boost.png",
  },
  {
    title: "VIP Access",
    description: "Unlock VIP privileges with higher rewards.",
    buttonText: "Learn More",
    image: "/assets/img/vip.png",
  },
];

const currentIndex = ref(0);
const visibleSlides = ref(3);

const updateVisibleSlides = () => {
  const w = window.innerWidth;
  if (w < 640) {
    visibleSlides.value = 1; // mobile
  } else if (w < 1024) {
    visibleSlides.value = 2; // tablet
  } else {
    visibleSlides.value = 3; // desktop
  }
};

onMounted(() => {
  updateVisibleSlides();
  window.addEventListener("resize", updateVisibleSlides);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateVisibleSlides);
});

const nextSlide = () => {
  if (currentIndex.value < promos.length - visibleSlides.value) {
    currentIndex.value++;
  }
};

const prevSlide = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  transition: transform 0.6s ease;
  width: 100%;
}

.promo-card {
  flex: 0 0 calc(100% / 3 - 1.5rem);
  margin: 0 0.75rem;
  position: relative;
  min-height: 16.75rem;
  color: white;
}

@media only screen and (max-width: 1024px) {
  .promo-card {
    flex: 0 0 calc(100% / 2 - 1.5rem);
  }
}

@media only screen and (max-width: 640px) {
  .promo-card {
    flex: 0 0 calc(100% - 1.5rem);
  }
}

.promo-img {
  position: absolute;
  top: -35px;
  right: 0;
  object-fit: cover;
  z-index: 1;
}

.promo-content {
  position: relative;
  padding: 1.75rem 2.5rem;
  background: rgb(36, 36, 40);
  height: 100%;
  display: flex;
  overflow: hidden;
  border-radius: 2rem;
  flex-direction: column;
  justify-content: flex-end;
}

.promo-bg {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.promo-content h3 {
  z-index: 2;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.promo-content p {
  z-index: 2;
  font-size: 0.75rem;
  margin-bottom: 1rem;
  color: #ddd;
  max-width: 16rem;
}

.promo-btn {
  border-color: rgb(19 87 77);
  background-color: rgb(15 80 70);
  padding: 0.75rem 1.2rem;
  border-radius: 9999px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;
}

/* Nav Buttons */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 3rem;
  width: 3rem;
  border: 2px solid rgb(31 122 108);
  color: white;
  font-size: 2rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  --tw-border-opacity: 1;
  --tw-bg-opacity: 1;
  background-color: rgb(15 80 70);
}

.prev {
  left: 0;
}
.next {
  right: 0;
}

@media only screen and (max-width: 480px) {
  .nav-btn {
    height: 2.25rem;
    width: 2.25rem;
    font-size: 1.5rem;
  }
  .promo-img {
    width: 60%;
    max-width: 60%;
    top: -10px;
    right: 0;
  }
}
</style>
